module.exports = __webpack_public_path__ + "img/chromeIcon.a29a2223.svg";